import { mutatorAction } from 'satcheljs';

import type FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import type { FolderItemViewState } from '../store/schema/FileProviderItemViewState';

export default mutatorAction(
    'updateFilePickerSelectedFolder',
    (state: FilePickerPanelViewState, folder: FolderItemViewState) => {
        state.filePickerViewState.selectedFolder = folder;
    }
);
